import { getParentLanguage } from "./getParentLanguage";
import { checkIfValidLanguage } from "./checkIfValidLanguage";

export { getParentLanguage, checkIfValidLanguage };
